<template>
    <div>
        <Loading />
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";

export default {
    name: "automatic-room-asignation",
    components: {
        Loading,
    },
    async mounted() {
        let roomId = await this.createRoom();
        if (roomId !== undefined && roomId !== undefined) {
            this.$router.push({
                name: "room",
                params: { roomId: roomId },
            });
        }
    },
    methods: {
        async createRoom() {
            let request = {
                name: this.roomName,
                description: this.description,
            };
            let response = await RepositoryFactory.conference.create(request);
            return response.data;
        },
    },
};
</script>